module.exports = __webpack_public_path__ + "img/2020.09.973aaad0.png";